/*
 * Task Type CC (credit card) - handle credential collection for a credit card.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Autocomplete, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { getValueForRender } from '../../utils/InputUtils';
import valid from 'card-validator';
import { AddCard } from '@mui/icons-material';
import FundingSourceTile from '../paymentsources/FundingSourceTile';

import ISO_COUNTRIES from './iso_countries';

const styleSheet = theme => ({
  labelField: {
    width: 80,
  },
  emailField: {
    minWidth: 336,
  },
  additionalFields: {
    minWidth: 336,
  },
  iconButton: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
  },
  iconButtonAction: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 3,
    paddingBottom: 2,
  },
  iconButtonRightMargin: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
    marginRight: 36,
  },
});

class AdornmentIcon extends Component {
  render() {
    if (this.props.brand === 'mastercard') {
      return (
        <SvgIcon>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 152.4 108">
            <g>
            <rect y="0" width="152.4" height="108" fill="none"/>
            <g>
              <rect x="60.4" y="25.7" width="31.5" height="56.6" fill="#FF5F00"/>
              <path fill="#EB001B" d="M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3
                c13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z"/>
              <path fill="#F79E1B" d="M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6
                c15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z"/>
            </g>
          </g>
          </svg>
        </SvgIcon>
      );
    } else if (this.props.brand === 'visa') {
      return (
        <SvgIcon>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 3384.5 2077.9">
          <path fill="#1434CB"  d="M1299.6,530.4L872.2,1549.9H593.4L383.1,736.5c-12.8-50.2-23.8-68.5-62.7-89.6
	c-63.4-34.3-168.1-66.6-260.1-86.7l6.3-29.6h448.8c57.1,0,108.6,38.1,121.5,104l111,589.9l274.5-693.9L1299.6,530.4L1299.6,530.4z
	 M2391.9,1217.2c1.2-269.1-372.1-283.9-369.6-404.1c0.8-36.5,35.7-75.5,111.9-85.3c37.7-4.9,141.9-8.7,259.9,45.6l46.2-216.2
	c-63.4-23-145.2-45.2-246.7-45.2c-260.6,0-444.2,138.6-445.7,336.9c-1.7,146.7,130.9,228.7,230.9,277.4
	c102.8,50,137.4,82.1,136.8,126.7c-0.7,68.3-81.9,98.6-157.9,99.8c-132.6,2-209.4-35.9-270.8-64.4l-47.8,223.4
	c61.5,28.2,175.4,52.9,293.2,54.2C2209.8,1566.1,2391,1429.1,2391.9,1217.2 M3080.4,1550.1h243.9l-213-1019.7h-225.1
	c-50.7,0-93.3,29.4-112.2,74.8l-395.8,944.7h276.9l54.9-152.3h338.5L3080.4,1550.1z M2786.1,1188.8L2925,806l79.9,382.8H2786.1z
	 M1676.3,530.4l-218.1,1019.5h-263.7l218.1-1019.5H1676.3L1676.3,530.4z"/>
          </svg>        
        </SvgIcon>
      );
    } else if (this.props.brand === 'american-express') {
      return (
        <SvgIcon>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 80 80">
            <polygon fill="#FFFFFF" points="15,16 15,40.9 15,66 40,66 65,66 65,41 65,16 40,16 15,16 "/>
            <path fill="#006FCF" d="M56.1,28.3l1.6-4.4H65V16H15v50h50v-7.9h-6.9l-2.5-3l-2.7,3H33.3V42.2h-6.5l8.1-18.3h7.9l1.9,4.1v-4.1h9.8
	L56.1,28.3L56.1,28.3z M50.6,31.2l0-1.8l0.7,1.8l3.2,8.7h3.2l3.3-8.7l0.6-1.7v10.4H65V26.5h-5.7l-2.6,6.8l-0.7,1.8l-0.7-1.8
	l-2.6-6.8h-5.7v13.3h3.4V31.2L50.6,31.2z M43.2,39.8h3.9l-5.9-13.3h-4.5l-5.9,13.3h3.9l1-2.6h6.5L43.2,39.8L43.2,39.8z M38.3,31
	l0.7-1.7l0.7,1.7l1.4,3.4h-4.1L38.3,31L38.3,31z M36,42.2v13.3h11.1v-2.9h-7.7v-2.3H47v-2.9h-7.6v-2.3h7.7v-2.9H36L36,42.2z
	 M59.5,55.5H64l-6.2-6.7l6.2-6.6h-4.4l-4,4.3l-4-4.3h-4.4l6.2,6.7l-6.2,6.6h4.3l4.1-4.3L59.5,55.5L59.5,55.5z M61.2,48.8l3.8,3.8
	v-7.6L61.2,48.8L61.2,48.8z"/>
          </svg>        
        </SvgIcon>
      );
    }

    return (
      <AddCard/>
    );
  }
}

class TaskTypeCC extends Component {

  constructor(props) {
    super(props);

    this.countries = Object.keys(ISO_COUNTRIES);

    this.state = {
      mountDone:            0,
      brand:                null,
      pan:                  null,
      expy:                 null,
      cvv:                  null,
      firstName:            null,
      lastName:             null,
      address1:             null,
      address2:             null,
      postalCode:           null,
      city:                 null,
      country:              null,
      state:                null,
      cardValid:            null,
    };
  }

  componentDidMount() {

    const { callPartnerApi, decryptOneTimeEncryptedValue } = this.props.auth;

    let theTask = this.props.task;

    if (theTask.ccId != null && this.props.done === false) {
      // Initiate promise chain.
      Promise.resolve()  
      .then(() => {
        // We've got an encrypted pan/cvv, and want the decrypted version.  We also will employ
        // additional encryption in transit (which is duplicative to TLS, but is an extra defense
        // against sniffing).  So:
        // - call the server side "getDecryptedCard"
        // - this returns a decryptString and a oneTimeKeyId
        // - call the server side "getOneTimeKey" operation, passing the oneTimeKeyId as a parameter
        // - use the returned key to decrypt the decryptString
        //

        let payload = {
          operation: "getDecryptedCard",
          params: {
            accountId: theTask.assignedAccountId,
            ccId: theTask.ccId
          }
        };

        // console.log('call getDecryptedCard');
        return callPartnerApi('appbind/generic',
                              'POST',
                              payload);
      })
      .then((response) => {
        return response.json();
      })
      .then((jresp) => {
        // console.log(JSON.stringify(jresp));
        let theKeyId = jresp.theKeyId;
        let decryptResp = jresp.decryptResp;

        return decryptOneTimeEncryptedValue(theKeyId, decryptResp, callPartnerApi);
      })
      .then((unencrypted) => {
        if (unencrypted != null) {
          // The unencrypted string should be JSON for the credit card info, so parse and set state from it.
          let cInfo = JSON.parse(unencrypted);

          // console.log('cInfo=' + JSON.stringify(cInfo));

          // Adjust the state values
          // - formatting for pan and expy
          // - region is a JSON object - pull it from the ISO structure

          let pan = cInfo.ccPan;
          // console.log('pan=' + pan);
          pan = pan.split(/(.{4})/).filter((s)=>s.length).join(" ").trim();
          // console.log('adjusted pan=' + pan);

          let expy = cInfo.ccExpy;
          // console.log('expy=' + expy);
          if (expy != null && expy.length > 2) {
            expy = expy.slice(0, 2) + ' / ' + expy.slice(2);
          }
          // console.log('adjusted expy=' + expy);

          // Find the region entry in the ISO_COUNTRIES structure
          let theRegion = {
            region_code: cInfo.state
          };
          // console.log('country regions: ' + JSON.stringify(ISO_COUNTRIES[cInfo.country].regions));

          let theCountry = ISO_COUNTRIES[cInfo.country];
          let theRegions = theCountry.regions;

          // iterate over the regions
          for (let key in theRegions) {
            if (theRegions.hasOwnProperty(key)) {
              let value = theRegions[key];
              if (value.region_code === cInfo.state) {
                theRegion = value;
                break;
              }
            }
          }

          //console.log('region lookup, there are ' + ISO_COUNTRIES[cInfo.country].regions.length + ' regions for ' + cInfo.country);
          /*
          for (let i=0; i<ISO_COUNTRIES[cInfo.country].regions.length; i++) {
            let region = ISO_COUNTRIES[cInfo.country].regions[i];
            console.log('region=' + JSON.stringify(region));
            if (region.region_code === cInfo.state) {
              theRegion = region;
              break;
            }
          }
          */

          this.setState({
            mountDone: 1,
            brand: cInfo.ccBrand,
            pan: pan,
            expy: expy,
            cvv: cInfo.ccCvv,
            last4: cInfo.ccLast4,
            firstName: cInfo.firstName,
            lastName: cInfo.lastName,
            address1: cInfo.address1,
            address2: cInfo.address2,
            postalCode: cInfo.postalCode,
            city: cInfo.city,
            country: cInfo.country,
            state: theRegion
          });
        } else {
          this.setState({mountDone: 1});
        }
      })
      .catch((error) => {
        //not sure what we can do
        this.setState({mountDone: 1});
      });
    } else {
      this.setState({mountDone: 1});
    }
  }

  handleDoneFromParent() {
    const { callPartnerApi, encryptOneTimeEncryptedValue } = this.props.auth;

    // TODO: validate input

    // Use a one-time code to encrypt in transit
    let theTask = this.props.task;

    let cInfo = {
      flowTaskId: theTask.flowTaskId,
      ccId: theTask.ccId,
      brand: this.state.brand,
      pan: this.state.pan,
      expy: this.state.expy,
      cvv: this.state.cvv,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      address1: this.state.address1,
      address2: this.state.address2,
      postalCode: this.state.postalCode,
      city: this.state.city,
      country: this.state.country,
      state: this.state.state
    };

    let cInfoString = JSON.stringify(cInfo);

    return new Promise(function(resolve, reject) {
      let theResponse = {
        status: -1,
        message: 'Unidentified error'
      };

      Promise.resolve()  
      .then(() => {
        // encrypt
        // console.log('encrypting card');
        return encryptOneTimeEncryptedValue(cInfoString, callPartnerApi);
      })
      .then((jresp) => {
        if (jresp != null && jresp.status === 0) {
          let theKeyId = jresp.keyId;
          let encryptedData = jresp.encryptedData;
          let payload = {
            operation: "createOrUpdateCC",
            params: {
              "accountId": theTask.assignedAccountId,
              "keyId": theKeyId,
              "encryptedData": encryptedData,
            }
          }

          return callPartnerApi('appbind/generic',
                                'POST',
                                  payload);
        } else {
          return null;
        }
      }).then(()=> {
        theResponse.status = 0;
        theResponse.message = 'Success';
        resolve(theResponse);
        return;
      })
      .catch(error => {
        theResponse.status = -2;
        theResponse.message = 'Error: ' + JSON.stringify(error);
        reject(theResponse);
        return;
      });
    });
  }

  handleCardNumberChange = (event) => {
    let input = event.target.value;

    // Remove non-digit characters
    input = input.replace(/\D/g, '');

    /*
    numberValidation={"card":{"niceType":"Visa",type:"visa","patterns":[4],"gaps":[4,8,12],"lengths":[16,18,19],"code":{"name":"CVV","size":3},"matchStrength":1},"isPotentiallyValid":true,"isValid":false}
    numberValidation={"card":{"niceType":"American Express","type":"american-express","patterns":[34,37],"gaps":[4,10],"lengths":[15],"code":{"name":"CID","size":4},"matchStrength":2},"isPotentiallyValid"=true,"isValid":false}
    */

    // Use the card-validator library to validate the card number and set the card type
    let cardType = '';
    let cardTypeDisplay = '';
    let panLength = 16;
    let cvvLength = 3;
    let cvvName = 'CVV';
    let gaps = [4,8,12];

    let numberValidation = valid.number(input);
    let panIsValid = numberValidation.isValid;
    //console.log('numberValidation=' + JSON.stringify(numberValidation));
    if (numberValidation.card != null) {
      cardType = numberValidation.card.type;
      cardTypeDisplay = numberValidation.card.niceType;
      panLength = numberValidation.card.lengths[0];
      gaps = numberValidation.card.gaps;
      cvvLength = numberValidation.card.code.size;
      cvvName = numberValidation.card.code.name;
    }


    if(input.length > panLength)
      input = input.slice(0,panLength);

    // Put separators in according to the card patterns
    let blocks = [];
    for (let i=0; i<gaps.length; i++) {
      if (i === 0) {
        // First block.  So input up to the first gap.
        if (input.length > gaps[i]) {
          blocks.push(input.substring(0, gaps[i]));
        } else {
          blocks.push(input);
          break;
        }
      } else if (i === gaps.length - 1) {
        if (input.length > gaps[i]) {
          blocks.push(input.substring(gaps[i-1], gaps[i]));
          blocks.push(input.substring(gaps[i]));
        } else {
          blocks.push(input.substring(gaps[i-1]));
        }
      } else {
        if (input.length > gaps[i]) {
          blocks.push(input.substring(gaps[i-1], gaps[i]));
        } else {
          blocks.push(input.substring(gaps[i-1]));
          break;
        }
      }
    }

    let gappedInput = blocks.join(' ').trim();

    this.setState({pan: gappedInput, brand: cardType, cardValid: panIsValid});
    this.checkCompleteDisabled("pan", gappedInput);
  }

  handleExpiryChange = (event) => {
    let input = event.target.value;

    // Remove non-digit characters
    input = input.replace(/\D/g, '');
    if(input.length > 4)
      input = input.slice(0,4);

    // Add the " / " separator after the 2nd digit
    if (input.length > 2) {
      input = input.slice(0, 2) + ' / ' + input.slice(2);
    }

    /*
    this.props.onChange && this.props.onChange({
      key: 'ccexp',
      value: input
    })
    */
    this.setState({expy: input});
    this.checkCompleteDisabled("expy", input);
  }

  setStateAttribute = (attribute, value) => {
    this.setState({[attribute]: value});
    this.checkCompleteDisabled(attribute, value);
  }

  checkCompleteDisabled(changedAttribute, value) {
    // Values to check.
    let pan = this.state.pan;
    if (changedAttribute === 'pan') {
      pan = value;
    }
    let expy = this.state.expy;
    if (changedAttribute === 'expy') {
      expy = value;
    }
    let cvv = this.state.cvv;
    if (changedAttribute === 'cvv') {
      cvv = value;
    }
    let firstName = this.state.firstName;
    if (changedAttribute === 'firstName') {
      firstName = value;
    }
    let lastName = this.state.lastName;
    if (changedAttribute === 'lastName') {
      lastName = value;
    }
    let address1 = this.state.address1;
    if (changedAttribute === 'address1') {
      address1 = value;
    }
    let postalCode = this.state.postalCode;
    if (changedAttribute === 'postalCode') {
      postalCode = value;
    }
    let city = this.state.city;
    if (changedAttribute === 'city') {
      city = value;
    }
    let country = this.state.country;
    if (changedAttribute === 'country') {
      country = value;
    }
    let state = this.state.state;
    if (changedAttribute === 'state') {
      state = value;
    }

    // Parent state
    let parentCompleteDisabled = this.props.isCompleteDisabled();

    let stateCompleteDisabled = this.isCompleteDisabled(pan, expy, cvv, firstName, lastName, address1, postalCode, city, country, state);

    if (parentCompleteDisabled !== stateCompleteDisabled) {
      this.props.setCompleteDisabled(stateCompleteDisabled);
    }
  }

  isCompleteDisabled(pan, expy, cvv, firstName, lastName, address1, postalCode, city, country, state) {
  
    // Pan
    let thePan = pan;

    if (thePan == null || thePan.length === 0) {
      return true;
    }
    thePan = thePan.replace(/\D/g, '');

    let numberValidation = valid.number(thePan);
    // console.log('numberValidation=' + JSON.stringify(numberValidation));

    if (numberValidation.isValid === false) {
      // console.log('card number ' + thePan + ' is invalid');
      return true;
    }

    // console.log('card number ' + thePan + ' is valid');

    // Expy
    if (expy == null || expy.length < 4) {
      return true;
    }
    expy = expy.replace(/\D/g, '');
    if (expy.length < 4) {
      return true;
    }

    // CVV
    if (cvv == null || cvv.length < 3) {
      return true;
    }

    // firstName
    if (firstName == null || firstName.length < 1) {
      return true;
    }
    // lastName
    if (lastName == null || lastName.length < 1) {
      return true;
    }
    // address1
    if (address1 == null || address1.length < 1) {
      return true;
    }
    // city
    if (city == null || city.length < 1) {
      return true;
    }
    // state
    if (state == null || state.length < 1) {
      return true;
    }
    // postalcode
    if (postalCode == null || postalCode.length < 1) {
      return true;
    }
    // country
    if (country == null || country.length < 1) {
      return true;
    }

    return false;  
  }

  render() {
    const classes = this.props.classes;

    if (this.state.mountDone === 0) {
      return (
        <div>Loading...</div>
      );
    }

    let theResellerName = 'Your agent';
    if (this.props.requestor) {
      theResellerName = this.props.requestor;
    }
    let theTitleStart = theResellerName + ' ';
    let theTitleCta = 'requests a credit card';
    let theTitleEnd = ' to pay for subscriptions they sign up for on your behalf.';

    let omitTitle = false;
    if (this.props.omitTitle === true) {
      omitTitle = true;
    }

    if (this.props.done === true) {
      let theTitle = "You've shared your credit card with " + theResellerName + ' to pay for subscriptions they sign up for on your behalf.';

      // simple read-only display - show info from parent   just show expy and last4 from parent
      let theTask = this.props.task;
      let brand = '';
      let last4 = '';
      let expy = '';
      let firstName = '';
      let lastName = '';
      if (theTask.ccOnFileTByCcId != null) {
        brand = theTask.ccOnFileTByCcId.ccBrand;
        last4 = theTask.ccOnFileTByCcId.ccLast4;
        expy = theTask.ccOnFileTByCcId.ccExpy;
        firstName = theTask.ccOnFileTByCcId.firstName;
        lastName = theTask.ccOnFileTByCcId.lastName;
      }

      /*
      if (last4 === '' && this.state.pan != null && this.state.pan.length > 0) {
        last4 = this.state.pan.slice(-4);
      }
      if (expy === '' && this.state.expy != null && this.state.expy.length > 0) {
        expy = this.state.expy;
      }
      */

      let theBrand = '';
      if (brand === 'visa') {
        theBrand = 'Visa';
      } else if (brand === 'mastercard') {
        theBrand = 'MasterCard';
      } else if (brand === 'american-express') {
        theBrand = 'American Express';
      } else if (brand === 'discover') {
        theBrand = 'Discover';
      }

      return (
        <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
          <Grid item xs={12}>
            <Typography variant="body1">{theTitle}</Typography>
          </Grid>
          {theBrand !== '' &&
          <Grid item xs={12}>
            <FundingSourceTile 
              psType={0}
              ccBrand={theBrand}
              ccLast4={last4}
              ccExpy={expy}
              firstName={firstName}
              lastName={lastName}
            />
          </Grid>}
        </Grid>
      );
    }

    let pan        = getValueForRender(this.state.pan,       '');
    let expy       = getValueForRender(this.state.expy,      '');
    let cvv        = getValueForRender(this.state.cvv,       '');
    let firstName  = getValueForRender(this.state.firstName, '');
    let lastName   = getValueForRender(this.state.lastName,  '');
    let address1   = getValueForRender(this.state.address1,  '');
    let address2   = getValueForRender(this.state.address2,  '');
    let postalCode = getValueForRender(this.state.postalCode,'');
    let city       = getValueForRender(this.state.city,      '');
    let country    = getValueForRender(this.state.country,   null);
    let state      = getValueForRender(this.state.state,     null);

    let brand      = getValueForRender(this.state.brand,     null);
    // console.log('render, brand is ' + brand);

    let helperText = ' ';
    if (this.state.cardValid === false) {
      helperText = 'Invalid card number';
    }

    const regions = (
         country 
      && ISO_COUNTRIES[country] 
      && ISO_COUNTRIES[country].regions 
    ) ? Object.values(ISO_COUNTRIES[country].regions) : [];

    let adornment = true;

    return (
      <Grid container spacing={2} justifyContent="flex-start" alignItems="center">

        {omitTitle === false &&
        <React.Fragment>
          {this.props.title != null && this.props.title.length > 0 &&
          <Grid item xs={12}>
            <Typography variant="h6">{this.props.title}</Typography>
          </Grid>}

          <Grid item xs={12}>
            <Typography variant="body1">{theTitleStart}<strong>{theTitleCta}</strong>{theTitleEnd}</Typography>
          </Grid>
        </React.Fragment>}

        {adornment === true &&
        <Grid item xs={12} sm={6}>
          <Grid item>
            <TextField
              label="Credit Card Number"
              name="ccnumber"
              value={pan}
              variant="outlined"
              required
              fullWidth
              onChange={(e) => { this.handleCardNumberChange(e); }}
              InputProps={
                {placeholder:'1234 1234 1234 1234',
                 startAdornment: (<InputAdornment position="start"><AdornmentIcon brand={brand}/></InputAdornment>)}
              }
              InputLabelProps={{ shrink: true }}
              helperText={helperText}
            />
          </Grid>
        </Grid>}
        
        {adornment === false &&
        <Grid item xs={12} sm={6}>
          <Grid container spacing={1} justifyContent="space-between" alignItems="flex-start">
            <Grid item>
              {brand === 'visa' &&
              <img alt="Visa" height="36px" src={'/cards/visa-logo.png'} />}
              {brand === 'mastercard' &&
              <img alt="MasterCard" height="48px" src={'/cards/mc-logo.png'} />}
              {brand === 'american-express' &&
              <img alt="AmericanExpress" height="39px" src={'/cards/amex-logo.png'} />}
              {brand === 'discover' &&
              <img alt="Discover" height="36px" src={'/cards/discover-logo.png'} />}
              {brand == null &&
              <img alt="Default" height="36px" src={'/cards/bindcard-blank.png'} />}

            </Grid>
            <Grid item width='80%'>
              <TextField
                label="Credit Card Number"
                name="ccnumber"
                value={pan}
                variant="outlined"
                required
                fullWidth
                onChange={(e) => { this.handleCardNumberChange(e); }}
                InputProps={{placeholder:'1234 1234 1234 1234'}}
                InputLabelProps={{ shrink: true }}
                helperText={helperText}
              />
            </Grid>
          </Grid>
        </Grid>}
        <Grid item xs={6} sm={3}>
          <TextField
            label="Expiration Date"
            name="ccexp"
            value={expy}
            variant="outlined"
            required
            onChange={(e) => { this.handleExpiryChange(e); }}
            InputProps={{
              placeholder:'MM / YY', 
              maxLength: 7
            }}
            InputLabelProps={{ shrink: true }}
            helperText=" "
            />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            label="CVC / CVV"
            name="cvv"
            value={cvv}
            variant="outlined"
            required
            fullWidth
            onChange={e => { this.setStateAttribute("cvv", e.target.value); }}
            InputProps={{
              placeholder:'012',
              pattern:'[0-9]{3,4}',
              maxLength: 4
            }}
            InputLabelProps={{ shrink: true }}
            helperText=" "
          />
        </Grid>
        <Grid item xs={12} style={{marginTop: -20}}><hr style={{borderTop:'solid 1px #eee',borderBottom:0,borderLeft:0,borderRight:0}}/></Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="First Name"
            name="firstName"
            variant="outlined"
            required
            fullWidth
            value={firstName}
            onChange={e => { this.setStateAttribute("firstName",e.target.value); }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Last Name"
            name="lastName"
            variant="outlined"
            required
            fullWidth
            value={lastName}
            onChange={e => { this.setStateAttribute("lastName", e.target.value); }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Street Address 1"
            name="address1"
            variant="outlined"
            required
            fullWidth
            value={address1}
            onChange={e => { this.setStateAttribute("address1", e.target.value); }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Street Address 2 (optional)"
            name="line2"
            variant="outlined"
            fullWidth
            value={address2}
            onChange={e => { this.setState({address2: e.target.value}); }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="City"
            name="city"
            variant="outlined"
            required
            fullWidth
            value={city}
            onChange={e => { this.setStateAttribute("city", e.target.value); }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={this.countries}
            getOptionLabel={option => ISO_COUNTRIES[option].country}
            disablePortal
            renderInput={params =>
              <TextField
                label="Country"
                name="country"
                variant="outlined"
                required
                fullWidth
                {...params}
              />
            }
            value={country}
            onChange={(event, value) => { this.setStateAttribute("country", value); }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={regions}
            getOptionLabel={option => option.region}
            disablePortal
            renderInput={params =>
              <TextField
                label={(country ? ISO_COUNTRIES[country].region_label : null) || "State / Province"}
                name="state"
                variant="outlined"
                required={!!regions.length}
                fullWidth
                {...params}
              />
            }
            disabled={!regions.length}
            value={state}
            onChange={(event, value) => { this.setStateAttribute("state", value); }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Postal Code"
            name="postalCode"
            variant="outlined"
            required
            fullWidth
            value={postalCode}
            onChange={e => { this.setStateAttribute("postalCode", e.target.value); }}
          />
        </Grid>
      </Grid>
    );
  }
}

TaskTypeCC.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(TaskTypeCC);;
